import React, { useState, useEffect } from "react";
import { Button, Row, Col } from "react-bootstrap";
import { Loading } from "../components/Loading";
import Draggable from "react-draggable";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import RequestUtils from "../utils/requestUtils";
import ServiceCalls from "../utils/serviceCalls";
import "../styles/PopUps.css";
import CommonUtils from "../utils/siteUtils";

const ViewRequestPopUp = ({ Request }) => {
  const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (Request) {
      setIsLoading(false);
    }
  }, [Request]);

  const closePopup = () => {
    setOpen(false);
  };

  //Determine the modal header language based on request type
  const determineHeader = (requestType) => {
    switch (requestType) {
      case "CANCEL":
        return "Cancellation of ACH Payments";
      case "ENROLL":
        return "Authorization for ACH Payments";
      case "UPDATE":
        return "Request Bank Change";
      default:
        break;
    }
  };

  //Generate repetitive modal JSX
  const modalSection = (label, data, className) => {
    return (
      <Row style={{ marginTop: "4px" }}>
        <Col className={className}>{label}</Col>
        <Col className="view-request-data">{data}</Col>
      </Row>
    );
    };

    //Generate JSX to handle word break
    const wideModalSection = (label, data, className) => {
        return (
            <Row style={{ marginTop: "4px",width:"425px" }}>
                <Col className={className}>{label}</Col>
                <Col className="wordWrap-break">{data}</Col>
            </Row>
        );
    };

  //Generate JSX for each requestType
  const renderRequestType = (requestType) => {
      if (requestType === "UPDATE") {
          // DE792158 Update View Request Populating Wrong Data
          let requestStatus = RequestUtils.determineRequestStatus(Request.bankRequest.requestStatusId);
          let paymentMethod = Request.vendorRecord.vendorPayments[0].paymentMethod
          let originalBank = (requestStatus !== 'APPROVED')
              ? Request.vendorRecord.vendorBanks.filter(bank => bank.effStatus === "A")
              : Request.originalBankRecord;
          //Handle when a vendor does not have a bank
          if (requestStatus !== 'APPROVED' && originalBank.length === 0) {
              console.log('Vendor does not have a bank record. Using default')
              originalBank = {
                  "vendorBankId": 0.0,
                  "vendorId": "",
                  "vendorSetId": "",
                  "vendorRecordId": 0.0,
                  "effStatus": "",
                  "beneficiaryBank": "",
                  "dfiQualifier": "",
                  "bankAccountNumber": "",
                  "dfiNumber": "",
                  "ibanId": "",
                  "bankCode": "",
                  "branchId": "",
                  "intermediarySwiftId": "",
                  "bankKey": "",
                  "country": "",
              };
          }
          else if (requestStatus !== 'APPROVED' && originalBank.length > 0) {
              originalBank = originalBank[0];
          }

          let isEMEAPlus = CommonUtils.determineIfVendorIsEMEAPlus(Request.vendorRecord);

          //US8004166 render the existing address for the REMOVE section (UHGID only)
          const renderRemoveAddressSection = (originalBank, Request) => {
              if (!originalBank || !originalBank.bankAccountNumber) {
                  return null;
              }
              const approvedReqs = Request.vendorRecord.requests
                  ? Request.vendorRecord.requests.filter(r => r.requestStatusId === 2)
                  : [];
              if (approvedReqs.length > 0 && originalBank && originalBank.bankAccountNumber) {
                  // Sort by updatedDt descending
                  const request = approvedReqs.sort((a, b) => new Date(b.updatedDt) - new Date(a.updatedDt))[0];
                  if (
                      (!request.bankAddress && !request.bankCity && !request.bankState && !request.bankPostal) ||
                      RequestUtils.maskString(request.requestBank.bankAccountNumber) !== RequestUtils.maskString(originalBank.bankAccountNumber) ||
                      request.requestBank.dfiNumber !== originalBank.dfiNumber
                  ) {
                      return null;
                  } else {
                      return (
                          <>
                              {wideModalSection("Bank Address", <span>{request.bankAddress ? request.bankAddress.toUpperCase() : ""}</span>, "")}
                              {wideModalSection("", <span>{`${request.bankCity ? request.bankCity.toUpperCase() : ""}, ${request.bankState ? request.bankState.toUpperCase() : ""} ${request.bankPostal ? request.bankPostal.toUpperCase() : ""}`}</span>,"")}
                              {wideModalSection("", <span>USA</span>, "")}
                          </>

                      );
                  }
              }
              return null;
          };
                 
          return (
              <>    
                  {!isEMEAPlus && (                      
                          <Row>
                              <Col style={{ paddingLeft: '10px' }}>
                                  <h6>Supplier Tax ID</h6>
                              </Col>
                              <Col>{RequestUtils.maskTINString(Request.vendorRecord.taxIdNumber)}</Col>
                          </Row>
                  )}
                          <Row>            
                              <h6>Remove</h6>
                          </Row>
                  {(isEMEAPlus)
                      ? wideModalSection("Bank Country", <span>{originalBank.country}</span>, "") 
                      : wideModalSection("Bank Name", <span>{originalBank.beneficiaryBank}</span>, "")
                  }
                    
                  {//Account Number
                      (originalBank.bankAccountNumber)
                      ? wideModalSection(CommonUtils.determineVendorBankNumberLabel(originalBank.country, paymentMethod, originalBank.dfiQualifier),
                          <span>{RequestUtils.maskString(originalBank.bankAccountNumber)}</span>, "")
                      :<></>

                  }
                  { //DFI NUmber / ROUTING number
                      (originalBank.dfiNumber)
                          ? wideModalSection(CommonUtils.determineEMEAVendorBankRoutingLabel(originalBank.country, paymentMethod, originalBank.dfiQualifier),
                         <span>{originalBank.dfiNumber}</span>, "")
                    :<></>
                  }
                 
                  {//IBAN
                      (isEMEAPlus && originalBank.ibanId)
                          ? wideModalSection("IBAN", <span>{originalBank.ibanId}</span>, "")
                      :<></>
                   }
                 
                  { //SORT CODE / BANK ID
                      (isEMEAPlus && originalBank.bankCode)
                          ? wideModalSection(CommonUtils.determineEMEABankIDLabel(originalBank.country),
                              <span>{originalBank.bankCode}</span>, "")
                      : <></>
                  }
                  
                 
                  { //INTERMED SWIFT
                      (isEMEAPlus && originalBank.intermediarySwiftId)
                          ? wideModalSection("Intermediary Swift", <span>{originalBank.intermediarySwiftId}</span>, "")
                      : <></>
                  }
                  
            
                  {      //BRANCH ID
                      (isEMEAPlus && originalBank.branchId)
                          ? wideModalSection("Branch ID", <span>{originalBank.branchId}</span>, "")
                      : <></>
                  }
                        
                  {!isEMEAPlus && renderRemoveAddressSection(originalBank, Request)}

                  <Row className="view-request-spacer">
                        <h6>Replace</h6>
                  </Row>

                  {!isEMEAPlus && (
                      <Row>
                          <Col className="modal-subheader view-request-spacer">Depository Bank</Col>
                      </Row>
                  )}

                  {(isEMEAPlus)
                      ? wideModalSection("Bank Country", <span>{Request.bankRequest.requestBank.country}</span>, "")
                      : wideModalSection("Bank Name", <span>{Request.bankRequest.requestBank.beneficiaryBank}</span>, "")
                      
                  }
                   
                  { //Account Number
                      (Request.bankRequest.requestBank.bankAccountNumber)
                      ?wideModalSection(CommonUtils.determineVendorBankNumberLabel(Request.bankRequest.requestBank.country, paymentMethod, Request.bankRequest.requestBank.dfiQualifier),
                          <span>{Request.bankRequest.requestBank.bankAccountNumber}</span>, "")
                      :<></>
                  }
                 
                  { //DFI NUmber / ROUTING number
                      (Request.bankRequest.requestBank.dfiNumber)
                          ? wideModalSection(CommonUtils.determineEMEAVendorBankRoutingLabel(Request.bankRequest.requestBank.country, paymentMethod, Request.bankRequest.requestBank.dfiQualifier),
                              <span>{Request.bankRequest.requestBank.dfiNumber}</span>, "")
                          : <></>
                  }
                    
                  {//IBAN
                      (isEMEAPlus && Request.bankRequest.requestBank.ibanId)
                          ? wideModalSection("IBAN", <span>{Request.bankRequest.requestBank.ibanId}</span>, "")
                      : <></>
                  }
                 
                  { //SORT CODE / BANK ID
                      (isEMEAPlus && Request.bankRequest.requestBank.bankCode)
                          ? wideModalSection(CommonUtils.determineEMEABankIDLabel(Request.bankRequest.requestBank.country), <span>{Request.bankRequest.requestBank.bankCode}</span>, "")
                      : <></>
                  }

                  
                  {//INTERMED SWIFT
                      (isEMEAPlus && Request.bankRequest.requestBank.intermediarySwiftId)
                          ? wideModalSection("Intermediary Swift", <span>{Request.bankRequest.requestBank.intermediarySwiftId}</span>, "")
                      : <></>
                  }

                  
                  {//BRANCH ID
                      (isEMEAPlus && Request.bankRequest.requestBank.branchId)
                          ? wideModalSection("Branch ID", <span>{Request.bankRequest.requestBank.branchId}</span>, "")
                      : <></>
                  }
                                 
                  {//ADDRESS- UHG ID ONLY 
                      (!(isEMEAPlus) && Request.bankRequest.bankAddress)
                          ? wideModalSection("Bank Address", <span>{Request.bankRequest.bankAddress}</span>, "")
                      : <></>
                  }
                  { //ADDRESS- UHG ID ONLY 
                      (!(isEMEAPlus) && (Request.bankRequest.bankCity || Request.bankRequest.bankState || Request.bankRequest.bankPostal))
                          ? wideModalSection("", <span>{Request.bankRequest.bankCity}, {Request.bankRequest.bankState} {Request.bankRequest.bankPostal}</span>, "")
                      : <></>
                  }
                  {//ADDRESS- UHG ID ONLY 
                      (!(isEMEAPlus) && (Request.bankRequest.bankAddress || Request.bankRequest.bankCity || Request.bankRequest.bankState || Request.bankRequest.bankPostal) && Request.bankRecord.country)
                          ? wideModalSection("", <span>{Request.bankRecord.country}</span>, "")
                      : <></>
                  }

              </>
          );
      } else if (requestType === "CANCEL") {
      //DE797907: Cancel View Request Populating Wrong Data
      let bankRecord = Request.bankRecord;    
      return (
        <>
          <Row>
            <h6 style={{ fontSize: "83%" }}>
              Discontinue Electronic Funds Transfers to this bank account.
            </h6>
          </Row>
          {modalSection("Bank Name", bankRecord.beneficiaryBank, "")}
         
          {modalSection(
            "Account Number",
            bankRecord.bankAccountNumber,
            ""
              )}
              {modalSection("Routing Number", bankRecord.dfiNumber, "")}
        </>
      );
    } else if (requestType === "ENROLL") {
      return (
        <>
          <Row>
            <Col style={{ paddingLeft: "11px", fontWeight:"600" }}>
                Supplier Tax ID
            </Col>
            <Col>{RequestUtils.maskTINString(Request.vendorRecord.taxIdNumber)}</Col>
          </Row>
          <Row>
            <Col className="modal-subheader view-request-spacer">Depository Bank</Col>
          </Row>
          {modalSection("Bank Name", Request.bankRecord.beneficiaryBank, "")}
              {modalSection("Account Number", Request.bankRecord.bankAccountNumber, "")}
              {modalSection("Routing Number", Request.bankRecord.dfiNumber, "")}
              {(Request.bankRequest.bankAddress)
                  ? modalSection("Bank Address", Request.bankRequest.bankAddress, "")
                  :<></>
              }
              {(Request.bankRequest.bankAddress && (Request.bankRequest.bankCity || Request.bankRequest.bankState || Request.bankRequest.bankPostal))
                  ?modalSection(
                    "",
                    `${Request.bankRequest.bankCity}, ${Request.bankRequest.bankState} ${Request.bankRequest.bankPostal}`,
                      "")
                    :<></>
          }
              {(Request.bankRequest.bankAddress && Request.bankRecord.country)
                  ? modalSection("", Request.bankRecord.country, "")
                  : <></>
              }
        </>
      );
    }
  };

  //Generate entire modal body
  const renderModalBody = () => {
      console.log(`Going to view Bank Request ${Request}`);
      const isAccountSignatory = Request.requestor.email.toLowerCase() === Request.bankRequest.signatoryEmail.toLowerCase();
      let isEMEAPlus = CommonUtils.determineIfVendorIsEMEAPlus(Request.vendorRecord);
    return (
      <ModalBody>
        <div className="view-request-content">
          <Row style={{ marginBottom: "10px" }}>
            <Col>
              {renderRequestType(
                RequestUtils.determineRequestType(Request.bankRequest.requestTypeId)
              )}
            </Col>
            <Col>
              <Row>
                            {!isEMEAPlus && (
                                <Col className="view-request-row-spacer modal-subheader">
                                    Account signatory or authorized delegate? {isAccountSignatory ? "Yes" : "No"}
                                </Col>
                            )}  
 

              </Row>
                        <Row>
                            <Col className="modal-subheader">
                                {isEMEAPlus ? "Authorized Delegate" : "Account Signatory or Authorized Delegate"}
                            </Col>
                        </Row>  

                        {wideModalSection(isEMEAPlus ? "Last Name" : "Signatory Last Name", Request.bankRequest.signatoryLastName, "")}
                        {wideModalSection(isEMEAPlus ? "First Name" : "Signatory First Name", Request.bankRequest.signatoryFirstName, "")}
                        {wideModalSection(isEMEAPlus ? "Title" : "Signatory Title", Request.bankRequest.signatoryTitle, "")}
                        {wideModalSection(isEMEAPlus ? "Phone" : "Signatory Phone", Request.bankRequest.signatoryPhone, "")}
                       
                        {//wideModalSection
                            wideModalSection(isEMEAPlus ? "Email" : "Signatory Email", Request.bankRequest.signatoryEmail, "")}  
 

              {RequestUtils.determineRequestType(Request.bankRequest.requestTypeId) !== "CANCEL" ? (
                <>
                  <Row style={{ marginTop: "15px" }}>
                    <Col className="modal-subheader">UnitedHealth Group Contact</Col>
                  </Row>
                                {wideModalSection("Contact Last Name", Request.bankRequest.uhgcontactLastName, "")}
                                {wideModalSection("Contact First Name", Request.bankRequest.uhgcontactFirstName, "")}
                {(Request.bankRequest.uhgcontactTitle)
                                    ? wideModalSection("Contact Title", Request.bankRequest.uhgcontactTitle, "")
                    :<></>
                }
                {(Request.bankRequest.uhgcontactPhone)
                                    ? wideModalSection("Contact Phone", Request.bankRequest.uhgcontactPhone, "")
                    : <></>
                }
                {(Request.bankRequest.uhgcontactEmail)
                    ?wideModalSection(
                        "Contact Email",
                        Request.bankRequest.uhgcontactEmail,
                        "")
                    : <></>
                }
                </>
              ) : (
                <></>
              )}
            </Col>
          </Row>
          <Button className="request-details-popup-buttons" onClick={() => setOpen(false)}>
            Close
          </Button>
        </div>
      </ModalBody>
    );
  };

  return isLoading ? (
    <Loading />
  ) : !open ? (
    <Button
      id="mpa-button-popup"
      className="viewRequestBtn right btn btn-primary"
      onClick={() => setOpen((o) => !o)}
    >
      View Request
    </Button>
  ) : (
    <Draggable handle=".handle">
      {/* DE784120 Column Alignment Mismatched - Modal is larger to account for items like long email strings*/}
      <Modal centered={true} size="xl" isOpen={open} toggle={closePopup} fade={false}>
        <ModalHeader toggle={closePopup} className="handle view-request-header" close={<></>}>
          {determineHeader(RequestUtils.determineRequestType(Request.bankRequest.requestTypeId))}
        </ModalHeader>
        {renderModalBody()}
      </Modal>
    </Draggable>
  );
};

export default ViewRequestPopUp;
